var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFavoriteFill28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2228 22.4127C14.9952 23.6402 13.0048 23.6402 11.7773 22.4127L4.38104 15.0164C2.53965 13.1751 2.53965 10.1896 4.38104 8.34818L6.34818 6.38104C8.18957 4.53965 11.175 4.53965 13.0164 6.38104L14 7.36461L14.9836 6.38104C16.825 4.53965 19.8104 4.53965 21.6518 6.38104L23.619 8.34818C25.4603 10.1896 25.4603 13.1751 23.619 15.0164L16.2228 22.4127Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavoriteFill28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;